import { ELEMENT_TYPES } from '../../../../../types/hubEnums';
import { getWebsiteDomainByCountry } from '../../../../../util/helper/website';
import { PATH_HUB_CR_PAYMENT_QUERY, PATH_HUB_INVOICE_HISTORY } from '../../../../../util/pagePath';
import { MS_BILLING_AND_PAYMENTS_CHOICES } from './enums';

interface Choice {
  text: string;
  to: string;
  element?: ELEMENT_TYPES;
  external?: boolean;
  headerLabel?: string;
}

export function useGetChoices(country?: string): Array<Choice> {
  const domain = getWebsiteDomainByCountry(country);
  const {
    UPDATE_PAYMENT_AND_BILLING_DETAILS,
    VIEW_INVOICES_AND_STATEMENTS,
    QUERY_A_PAYMENT,
    REQUEST_CREDIT_REFUND,
    REVIEW_SERVICE_FEES,
    REVIEW_REFUND_POLICY,
    FOLLOW_UP_ON_A_CREDIT_REQUEST,
    REVIEW_PAYMENT_METHOD_OPTIONS,
  } = MS_BILLING_AND_PAYMENTS_CHOICES;
  return [
    { text: UPDATE_PAYMENT_AND_BILLING_DETAILS, to: PATH_HUB_INVOICE_HISTORY },
    { text: VIEW_INVOICES_AND_STATEMENTS, to: PATH_HUB_INVOICE_HISTORY },
    {
      text: QUERY_A_PAYMENT,
      to: PATH_HUB_CR_PAYMENT_QUERY,
      element: ELEMENT_TYPES.BUTTON,
      headerLabel: 'Billing and payments',
    },
    {
      text: REQUEST_CREDIT_REFUND,
      to: PATH_HUB_CR_PAYMENT_QUERY,
      element: ELEMENT_TYPES.BUTTON,
      headerLabel: 'Billing and payments',
    },
    {
      text: FOLLOW_UP_ON_A_CREDIT_REQUEST,
      to: PATH_HUB_CR_PAYMENT_QUERY,
      element: ELEMENT_TYPES.BUTTON,
      headerLabel: 'Billing and payments',
    },
    {
      text: REVIEW_SERVICE_FEES,
      to: `${domain}/service-fees`,
      element: ELEMENT_TYPES.ANCHOR,
    },
    {
      text: REVIEW_REFUND_POLICY,
      to: `${domain}/refund-policy`,
      element: ELEMENT_TYPES.ANCHOR,
    },
    { text: REVIEW_PAYMENT_METHOD_OPTIONS, to: PATH_HUB_INVOICE_HISTORY },
  ];
}
